// extracted by mini-css-extract-plugin
export default {"containerOutside":"_1AtzSjQw7TBDiaGeiSt-2N","containerInside":"_2PbWp9ATB0BPw29gSbUTkv","heading":"_2XtHAnSS3_QbRr4kIYNIN"};